<div class="input-group flex-nowrap">
  <span class="input-group-text"><i class="bi {{ iconClass }}"></i> </span>
  <input [(ngModel)]="localValue" step="{{ step }}" min="{{ min }}" max="{{ max }}"
    (ngModelChange)="onValueChange($event)" type="money" class="form-control form-control-lg"
    placeholder="{{ placeholder }}" />
</div>
